import { Fragment, useState } from "react";
import { SUPPORTED_INPUT_TYPES as types } from "../../util/constants";
import Address from "./Inputs/Address";
import DatePicker from "./Inputs/DatePicker";
import Radio from "./Inputs/Radio/";
import TextInput from "./Inputs/TextInput";
import Country from "./Inputs/Country";
import { Mui, MuiIcons } from "@osu/react-ui"
import { useCopyOnClick } from "../../../Common/hooks/useCopyOnClick";
import { mergeSxStyles } from "../../../util/functions";

const checkCopiable = (readOnly, type) => {
  if(!readOnly) {
    return false
  }
  return [
    types.textInput,
    types.dropdown,
    types.datepicker,
    types.numeric,
    types.decimal,
    types.currency,
    types.textArea,
    types.country,
  ].includes(type)
}

function Switch(props = {}) {
  const { dataType = "", defaultValue, value: _overrideValue, setValue: _overrideSetValue, showErrorForMissingField, shouldWrap, ...rest } = props;
  const uppercased = dataType.toUpperCase();
  const enableCopying = shouldWrap !== undefined 
    ? shouldWrap 
    : checkCopiable(rest?.readOnly, uppercased)
  const [value, setValue] = useState(defaultValue || "")
  const inputParms = {
    ...rest,
    value,
    setValue
  }
  if(_overrideSetValue) {
    inputParms.value = _overrideValue
    inputParms.setValue = _overrideSetValue
  }
  const isNum = [types.numeric, types.decimal, types.currency].includes(uppercased)
  if(isNum) {
    inputParms.type = rest?.type || "number"
    inputParms.step = rest?.step || "any"
  }
  if(types.currency === uppercased) {
    inputParms.step = rest?.step || "0.01"
    if(!rest?.round) {
      inputParms.truncateDecimals = 2
    }
  }

  if(types.country === uppercased && rest?.name === "countryOfAttribution") {
    inputParms.excludeOptions = ["USA", "United States"]
  }
  
  if(showErrorForMissingField && rest?.required && !inputParms.value) {
    inputParms.error = true
    inputParms.helperText = <Fragment>
      <MuiIcons.Warning titleAccess="warning" fontSize="inherit" />{" "}
      This field is required.
    </Fragment>
  }
  const { tooltipProps, inputProps: copyInputProps, title: toolTipTitle } = useCopyOnClick(inputParms.value, enableCopying)
  if(enableCopying) {
    if (uppercased === types.datepicker) {
      inputParms.slotProps = {
        ...inputParms.slotProps || {},
        textField: {
          ...inputParms.slotProps?.textField || {},
          inputProps: {
            ...inputParms.slotProps?.textField?.inputProps || {},
          },
          onClick: copyInputProps.onClick
        },
      };
      inputParms.sx = mergeSxStyles(inputParms.sx, copyInputProps.sx)
    } else {
      inputParms.onClick = copyInputProps.onClick
      inputParms.sx = mergeSxStyles(inputParms.sx, copyInputProps.sx)
    }
  }

  const renderInput = () => {
    switch (uppercased) {
      case types.textInput:
      case types.numeric:
      case types.decimal:
      case types.currency:
      case types.textArea:
        return <TextInput area={uppercased === types.textArea} {...inputParms} />;
      case types.address:
        return <Address showErrorForMissingField={showErrorForMissingField} {...inputParms} />;
      case types.radio:
        return <Radio {...inputParms} />;
      case types.datepicker:
        return <DatePicker {...inputParms} />;
      case types.country:
        return <Country {...inputParms} />;
      default:
        return false;
    }
  }

  if(enableCopying) {
    return <Mui.Tooltip title={toolTipTitle} {...tooltipProps}>
      <div>{renderInput()}</div>
    </Mui.Tooltip>
  }
  return renderInput()
}
export default Switch;
